import axios, { AxiosResponse } from 'axios';

const API_BASE = process.env.NODE_ENV === 'production' 
  ? 'https://blockcred-backend.onrender.com/api'
  : 'http://localhost:5000/api';


const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - return response.data directly
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    console.log(`✅ API Success: ${response.config.url}`);
    return response.data; // Return data directly, not the full response
  },
  (error) => {
    console.error(`❌ API Error: ${error.message}`);
    throw new Error(error.response?.data?.error || error.message || 'API Error');
  }
);

// Institution API - Enhanced with new endpoints
export const institutionAPI = {
  create: (data: any) => apiClient.post('/institution/create', data),
  list: (params?: any) => apiClient.get('/institution/list', { params }),
  read: (rollNumber: string) => apiClient.get(`/institution/read/${rollNumber}`),
  update: (rollNumber: string, data: any) => apiClient.put(`/institution/update/${rollNumber}`, data),
  delete: (rollNumber: string, data: any) => apiClient.post(`/institution/delete/${rollNumber}`, data),
  restore: (rollNumber: string, data: any) => apiClient.post(`/institution/restore/${rollNumber}`, data), // NEW
  getNotifications: (markRead?: boolean) => apiClient.get('/institution/notifications', { params: { mark_read: markRead } }), // NEW
  getVerificationRequests: () => apiClient.get('/institution/verification-requests'),
  approveVerification: (data: any) => apiClient.post('/institution/approve-verification', data)
};

// Student API
export const studentAPI = {
  view: (rollNumber: string) => apiClient.get(`/student/view/${rollNumber}`),
  reportMistake: (rollNumber: string, data: any) => apiClient.post(`/student/report-mistake/${rollNumber}`, data),
  getNotifications: (rollNumber: string) => apiClient.get(`/student/notifications/${rollNumber}`)
};

// Verifier API - Enhanced with basic details access
export const verifierAPI = {
  getBasicDetails: (rollNumber: string) => apiClient.get(`/verifier/basic-details/${rollNumber}`), // NEW
  request: (rollNumber: string, data: any) => apiClient.post(`/verifier/request/${rollNumber}`, data),
  verify: (rollNumber: string, data: any) => apiClient.post(`/verifier/verify/${rollNumber}`, data),
  status: (rollNumber: string, params: any) => apiClient.get(`/verifier/status/${rollNumber}`, { params })
};

// Health API
export const healthAPI = {
  check: () => apiClient.get('/health'),
  root: () => apiClient.get('/')
};

export default apiClient;
